import React, { useState } from "react";
import logoImage from "../../assests/images/logo.png";

function OTPConfirmation(props) {
  const [otp, setOtp] = useState(["", "", "", ""]); // Assuming a 4-digit OTP

  const handleChange = (index, event) => {
    const value = event.target.value;

    if (value.match(/^[0-9]$/) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value !== "" && index < newOtp.length - 1) {
        // Move to the next input box
        document.getElementById(`otpDigit${index + 2}`).focus();
      }
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && index > 0) {
      // Prevent the default behavior of the Backspace key
      event.preventDefault();
      // Clear the current input
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      // Move to the previous input box when backspace is pressed
      document.getElementById(`otpDigit${index}`).focus();
    }
  };

  const submitOtp = () => {
    props.submitOtp(2);
  };

  return (
    <>
      <div class="text-center">
        <div className="logo_login_react_vendors">
          <img src={logoImage} alt="" height="51" />
        </div>
        <h3 class="titles">Enter 4 Digit Code</h3>
        <p>Enter the 4 digit code that you recevied on your email.</p>
      </div>
      <form>
        <div class="mb-4 position-relative">
          <div className="list_block_enterotp">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                size="1"
                id={`otpDigit${index + 1}`}
                className="form-control form-input-otp"
                placeholder="0"
                pattern="[0-9]"
                title="Please enter a valid digit"
                required
                value={digit}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
              />
            ))}
          </div>
        </div>

        <div class="text-center mb-4">
          <button onClick={submitOtp} class="btn btn-primary btn-log reset-btn">
            Continue
          </button>
        </div>
      </form>
    </>
  );
}

export default OTPConfirmation;
